export default "__VITE_ASSET__cf11cf8f__"